<template>
	<div :class="customClass">
		<div v-if="loading" class="d-flex justify-content-center" :style="{'height': (loading ? '50px' : '0') }">
			<loader-circle class="loading-circle fetch-favorite-loading loading-circle--show" />
		</div>
		<template v-else>
			<bin-collection-schedule-download :fileDLAttach="dlFile" :icsBlobPath="icsBlobPath" v-if="!addressId" />
			<div class="row">
				<div class="col-12 pt-4">
					<div class="container" v-if="!addressId">
						<bin-collection-schedule-item
							v-for="(wSValue, wasteStreamBinSize) in list"
							:key="wasteStreamBinSize"
							:details="wSValue" />
					</div>
					<bin-collection-schedule-table v-else :list="list" :custom-table-header-color-style="customTableHeaderColorStyle" />
				</div>
			</div>
		</template>
	</div>
</template>
<script>
	import LoaderCircle from './LoaderCircle';
	import BinCollectionScheduleDownload from './BinCollectionScheduleDownload';
	import BinCollectionScheduleItem from './BinCollectionScheduleItem';
	import BinCollectionScheduleTable from './BinCollectionScheduleTable';
  import Helper from '../../helper';
  import DateNoTz from '../utils/DateNoTz'

	export default {
		props: {
			addressId: {
				type: Number
			},
			customClass: {
				type: String,
				default: 'container pt-4 pb-4 bin-collection-schedule'
			},
			customTableHeaderColorStyle: {
                type: String,
                default: ''
            }
		},
		data() {
			return {
				binTypes: [],
				freqTypes: [],
				calenSettings: [],
				nextCollectionDates: [],
				loading: true
			}
		},
		components: {
			LoaderCircle,
			BinCollectionScheduleDownload,
			BinCollectionScheduleItem,
			BinCollectionScheduleTable
		},
		mounted() {
      this.loadScheduleTypes();
      this.$store.dispatch('getServerDate')
		},
		methods: {
			loadScheduleTypes() {
				this.$store.dispatch('getBinScheduleSetting', ['bin-type', 'frequency-type', 'calendar-setting'])
					.then(dataList => {
						this.binTypes = dataList[0] && dataList[0].list;
						this.freqTypes = dataList[1] && dataList[1].list;
						this.calenSettings = dataList[2] && dataList[2].list;
						this.loadAddressCollectionWeek()
					});
			},
			loadAddressCollectionWeek() {
				this.$store.dispatch('getAddressCollectionWeek', (this.addressId || this.$route.query.id) )
					.then(data => {
						this.nextCollectionDates = (data && data.nextCollectionDates)
						.filter(item => {
							return parseInt(item.binSize) > 0;
						})
						.map(item => {
							item.binSize = item.binSize.trim();
							item.wasteStreamBinSize = `${item.binSize}:${item.wasteStream}`
							return item;
						});

						if (this.nextCollectionDates.length > 0) {
							this.$emit('show-tabs');
						} else {
							this.$emit('never-show-tabs');
						}
					})
					.catch(error =>{
						this.nextCollectionDates = []
						this.$emit('never-show-tabs');
					})
					.finally(() => {
						this.loading = false;
					})
			},
			getBin(wasteStream) {
				return this.binTypes.find(bin => bin.api_value === wasteStream);
			},
			getFreq(collectionFrequency) {
				return this.freqTypes.find(freq => freq.api_value === collectionFrequency);
			},
			getDisplayName(wasteStream) {
				const bin = this.getBin(wasteStream);
				return (bin && bin.name) || wasteStream;
			},
			getDisplayNote(wasteStream) {
				const bin = this.getBin(wasteStream);
				return (bin && bin.notes) || '';
			},
			getDisplayFreq(waste) {
				const freq = this.getFreq(waste.collectionFrequency);
				return (freq && freq.name) || waste.collectionFrequency;
			},
			getDisplayIcon(wasteStream) {
				const bin = this.getBin(wasteStream);
				return (bin && bin.icon) || '';
			}
		},
		computed: {
			list() {
				let wastesList = {};
				const wastes = Helper.objectsGroupBy(this.nextCollectionDates, 'wasteStreamBinSize');
				for (let wasteStreamBinSize in wastes) {
					if (wastes.hasOwnProperty(wasteStreamBinSize)) {
						const wasteCollection = wastes[wasteStreamBinSize];
						const [binSize, wasteStream] = wasteStreamBinSize.split(':');
						wastes[wasteStreamBinSize] = {
							displayName: this.getDisplayName(wasteStream),
							displayNote: this.getDisplayNote(wasteStream),
							displayIcon: this.getDisplayIcon(wasteStream),
							displayFrequency: this.getDisplayFreq(wasteCollection[0]),
							items: wasteCollection
						};
					}
				}

				return wastes;
      },
      serverDate : function(){
        var serverDate =  new DateNoTz(this.$store.getters.GET_SERVER_DATE.payload);
        return serverDate;
      },
      location(){
        return this.$store.getters.GET_BOOKING_HISTORY_ADDRESS
      },
      icsBlobPath(){
        /*
            Stry: [US454] As a user, I want to download calendar events to my mobile
            Date: 2021-01-15
            Auth: Franco Mapua
            Desc: Allows the downloading of an ics file with all the bin collection settings
        */
        var nextCollectionDates = this.nextCollectionDates
        if(!Array.isArray(nextCollectionDates) || nextCollectionDates.length == 0){
          return null
        }

        var icsContent = "BEGIN:VCALENDAR\n" +
          "VERSION:2.0\n" +
          "PRODID:-//bobbin v0.1//NONSGML iCal Writer//EN\n" +
          "CALSCALE:GREGORIAN\n" +
          "METHOD:PUBLISH\n"


        // --- Filter nextCollectionDates according to waste type
        if(Array.isArray(nextCollectionDates)){
          var hash = {}
          for (let i = 0; i < nextCollectionDates.length; i++) {
            const collectionSchedule = nextCollectionDates[i];

            var nextCollectionDate = new DateNoTz(collectionSchedule.nextCollectionDate)
            var searchWasteStream = collectionSchedule.wasteStream
            var hashEntry = hash[searchWasteStream]
            if(!hashEntry || !hashEntry.nextCollectionDate || hashEntry.nextCollectionDate.convertToSeconds() > nextCollectionDate.convertToSeconds()){
              hash[collectionSchedule.wasteStream] = {
                collectionSchedule
              }
            }
          }
          nextCollectionDates = []
          for (const wasteStream in hash) {
            if (Object.hasOwnProperty.call(hash, wasteStream)) {
              nextCollectionDates.push(hash[wasteStream].collectionSchedule)
            }
          }
        }

        var created = this.serverDate.formatYYYYMMDDTHHMMSSZ()
        var location = this.location
        // --- Itereate Over each event and append to the icsContent
        nextCollectionDates.forEach(collectionDates => {
          var description = `${collectionDates.binSize}L ${collectionDates.wasteStream} Collection`
          var collectionDate = new DateNoTz(collectionDates.nextCollectionDate).formatYYYYMMDD()

          icsContent += "BEGIN:VEVENT\n" +
            "DTSTART;VALUE=DATE:"+ collectionDate +"\n" +
            "DTSTAMP:" + created + "\n" +
            // "UID:1285935469767a7c7c1a9b3f0df8003a@yoursever.com\n" +
            "CREATED:" + created + "\n" +
            "LOCATION:" + location + "\n" +
            
            "LAST-MODIFIED:" + created + "\n" +
            "SEQUENCE:0\n" +
            "STATUS:CONFIRMED\n" +
            "SUMMARY:" + description + "\n" +
            "TRANSP:OPAQUE\n" +
            "BEGIN:VALARM\n" + 
            "ACTION:DISPLAY\n" +
            "DESCRIPTION:" + description + "\n" +
            "TRIGGER:-PT6H\n" +
            "END:VALARM\n" +
            "END:VEVENT\n" 
        });
        
        // --- End the ICS files
        icsContent += "END:VCALENDAR"
        var data = new File([icsContent], { type: "text/plain" });

        return window.URL.createObjectURL(data);
      },
			dlFile() {
				const frequencies = this.nextCollectionDates.map(f => f.collectionFrequencyCode);
				const calendar = this.calenSettings.find(c => {
					const freqs = c.frequency.split(',');
					let hasMatched = false;
					freqs.forEach(f => {
						if (!hasMatched && frequencies.includes(f.trim())) {
							hasMatched = true;
						}
					});
					return hasMatched;
				});
				return (calendar && calendar.file_path && JSON.parse(calendar.file_path)[0]) || '';
			}

		},
		watch: {
			list: function(data) {
				this.$emit('dataCountRetrieved', Object.keys(data || {}).length);
			}
		}
	}
</script>